import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["container", "item"];

  add(event) {
    event.preventDefault();
    const content = this.templateContent;
    this.containerTarget.insertAdjacentHTML("beforeend", content);
  }

  async remove(event) {
    event.preventDefault();

    const item = event.target.closest(
      "[data-referrals-nested-form-target='item']"
    );
    const idField = item.querySelector("input[name*='[id]']");
    const isPersisted = idField && idField.value;

    if (isPersisted) {
      const deleteUrl = event.target.dataset.deleteUrl;

      if (confirm("Are you sure you want to remove this referral?")) {
        const csrfToken = document.querySelector(
          'meta[name="csrf-token"]'
        ).content;

        const response = await fetch(deleteUrl, {
          method: "DELETE",
          headers: {
            "X-CSRF-Token": csrfToken,
            Accept: "text/vnd.turbo-stream.html",
          },
        });

        if (response.ok) {
          item.remove();
          this.submitMainForm();
        }
      }
    } else {
      item.remove();
    }
  }

  submitMainForm() {
    this.element.requestSubmit();
  }

  get templateContent() {
    const index = new Date().getTime();
    const template = document.getElementById("referral-template").innerHTML;
    return template.replace(/NEW_RECORD/g, index);
  }
}
